import { FaDownload } from "react-icons/fa";
import TopInfoBar from "../components/TopInfoBar";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Downloads() {

    const loanForms = [
        {
            id: 1,
            name: "Karmasathi Loan Application",
            file: "/forms/karmasathi-loan.pdf"
        },
        {
            id: 2,
            name: "Work Order Loan for Non-Individual (Alternative)",
            file: "/forms/work-order-non-individual.pdf"
        },
        {
            id: 3,
            name: "Work Order Loan for Non-Individual",
            file: "/forms/Work Order Loan for Non-indvidual.pdf"
        },
        {
            id: 4,
            name: "Vehicle Loan Application",
            file: "/forms/VEHICLE LOAN.pdf"
        },
        {
            id: 5,
            name: "Term Loan for Individual",
            file: "/forms/Term Loan for Indvidual.pdf"
        },
        {
            id: 6,
            name: "Term Loan for Non-Individual",
            file: "/forms/Term Loan for non-indvidual.pdf"
        },
        {
            id: 7,
            name: "Personal Loan Application",
            file: "/forms/Personal Loan Application From.pdf"
        },
        {
            id: 8,
            name: "Overdraft Loan Application",
            file: "/forms/OVERDRAFT LOAN APPLICATION.pdf"
        },
        {
            id: 9,
            name: "Home Building Loan (HBL) Application",
            file: "/forms/HBL application FORM.pdf"
        },
        {
            id: 10,
            name: "ECCS Loan Application Form",
            file: "/forms/ECCS Loan Application FORM.pdf"
        },
        {
            id: 11,
            name: "Cash Credit Loan for Individual",
            file: "/forms/Cash Cerdit Loan for Indvidual.pdf"
        },
        {
            id: 12,
            name: "Cash Credit Loan for Non-Individual",
            file: "/forms/Cash Cerdit Loan for Non-indvidual.pdf"
        },
        {
            id: 13,
            name: "SHG Loan Application Form",
            file: "/forms/SHG Application  Form.pdf"
        }
    ];

    const miscForms = [
        {
            id: 1,
            name: "Aadhaar Seeding Form",
            file: "/forms/AADHAAR SEEDING FORM.pdf"
        },
        {
            id: 2,
            name: "ATM Card Application",
            file: "/forms/ATM APPLICATION.pdf"
        },
        {
            id: 3,
            name: "Current Account Opening Form for Individual",
            file: "/forms/CURRENT ACCOUNT OPENING FORM FOR INDIVIDUAL.pdf"
        },
        {
            id: 4,
            name: "KYC Update Form",
            file: "/forms/KYC FORM.pdf"
        },
        {
            id: 5,
            name: "Multipurpose Request Form",
            file: "/forms/Multipurpose Request Form.pdf"
        },
        {
            id: 6,
            name: "NEFT / RTGS Application",
            file: "/forms/NEFT_RTGS Application.pdf"
        },
        {
            id: 7,
            name: "Account Nomination Form",
            file: "/forms/Nomination_Form.pdf"
        },
        {
            id: 8,
            name: "ATM Dispute / Problem Request Form",
            file: "/forms/Request for ATM Problem.pdf"
        },
        {
            id: 9,
            name: "Savings Bank (SB) Opening Form for Individual",
            file: "/forms/SB OPENING FORM FOR INDIVIDUAL.pdf"
        },
        {
            id: 10,
            name: "Savings Bank (SB) Opening Form for Non-Individual",
            file: "/forms/SB OPENING FORM FOR NON INDIVIDUAL.pdf"
        },
        {
            id: 11,
            name: "SMS Alert Form",
            file: "/forms/SMS Alert form.pdf"
        },
        {
            id: 12,
            name: "Standing Instruction Request Form",
            file: "/forms/Standing Instruction.pdf"
        },
        {
            id: 13,
            name: "Term Deposit (TD) Account Opening Form",
            file: "/forms/TD Account opening form.pdf"
        }
    ];

    const downloadFile = (fileUrl) => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileUrl.split("/").pop();
        link.click();
    };

    return (
        <>
            <div>
                <TopInfoBar />
                <Header />
                <Navbar />
            </div>
            <div className="max-w-7xl mx-auto px-4 py-10">
                {/* <h2 className="text-3xl font-bold text-center mb-10">
                Downloads
            </h2> */}

                <div className="grid md:grid-cols-2 gap-10">

                    {/* LEFT - Loan Application Forms */}
                    <div>
                        <h3 className="text-2xl font-semibold mb-4">Loan Application Form</h3>

                        <table className="w-full border text-sm">
                            <thead className="bg-gray-800 text-white">
                                <tr>
                                    <th className="p-3 border">Sl.No</th>
                                    <th className="p-3 border">Particulars</th>
                                    <th className="p-3 border">Form</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loanForms.map(item => (
                                    <tr key={item.id} className="border">
                                        <td className="p-3 border text-center">{item.id}</td>
                                        <td className="p-3 border">{item.name}</td>
                                        <td className="p-3 border text-center">
                                            <button
                                                onClick={() => downloadFile(item.file)}
                                                className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 flex items-center gap-2 mx-auto"
                                            >
                                                <FaDownload /> DOWNLOAD
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* RIGHT - Misc Application Forms */}
                    <div>
                        <h3 className="text-2xl font-semibold mb-4">Misc Application Form</h3>

                        <table className="w-full border text-sm">
                            <thead className="bg-gray-800 text-white">
                                <tr>
                                    <th className="p-3 border">Sl.No</th>
                                    <th className="p-3 border">Particulars</th>
                                    <th className="p-3 border">Form</th>
                                </tr>
                            </thead>
                            <tbody>
                                {miscForms.map(item => (
                                    <tr key={item.id} className="border">
                                        <td className="p-3 border text-center">{item.id}</td>
                                        <td className="p-3 border">{item.name}</td>
                                        <td className="p-3 border text-center">
                                            <button
                                                onClick={() => downloadFile(item.file)}
                                                className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 flex items-center gap-2 mx-auto"
                                            >
                                                <FaDownload /> DOWNLOAD
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            <div>
                <Footer />
            </div>
        </>
    );
}
